const helpTopics = [
  { title: 'Getting started with Carewinners', detail: 'Account setup, onboarding docs, and best practices.' },
  { title: 'Managing appointments', detail: 'Build schedules, assign caregivers, and send confirmations.' },
  { title: 'Live chat tips', detail: 'Stay in sync with users and triage high priority requests.' },
];

function HelpCenterPage() {
  return (
    <div className="space-y-6">
      <header>
        <p className="text-xs uppercase tracking-[0.6em] text-emerald-500">Help center</p>
        <h1 className="text-3xl font-semibold text-slate-900">Guides & resources</h1>
        <p className="text-slate-600">
          Browse self-serve articles so you can support caregivers, partners, and Carewinners admins without delay.
        </p>
      </header>
      <section className="space-y-4">
        {helpTopics.map((topic) => (
          <article
            key={topic.title}
            className="rounded-3xl border border-emerald-100 bg-white px-5 py-5 shadow-sm shadow-slate-200 transition hover:border-emerald-300"
          >
            <p className="text-lg font-semibold text-slate-900">{topic.title}</p>
            <p className="text-sm text-slate-500">{topic.detail}</p>
          </article>
        ))}
      </section>
      <section className="grid gap-6 md:grid-cols-2">
        <article className="rounded-3xl border border-emerald-100 bg-emerald-50/70 p-6 shadow-lg shadow-emerald-100">
          <p className="text-sm font-semibold uppercase tracking-[0.4em] text-emerald-600">Need help?</p>
          <h2 className="text-xl font-semibold text-slate-900">Chat with support</h2>
          <p className="mt-2 text-slate-600">
            Open a live chat from the Support tab and connect with the Carewinners help hub within seconds.
          </p>
        </article>
        <article className="rounded-3xl border border-emerald-100 bg-white p-6 shadow-sm shadow-slate-200">
          <p className="text-sm font-semibold uppercase tracking-[0.4em] text-emerald-600">Safety</p>
          <p className="mt-2 text-slate-600">All privileged data is encrypted end-to-end and monitored 24/7.</p>
        </article>
      </section>
    </div>
  );
}

export default HelpCenterPage;
